import React from "react";
import axios from "axios";
import {Route, BrowserRouter, Switch} from 'react-router-dom';
import Login from './component/auth/Login'
import Signup from './component/auth/Signup';
import Home from './component/home/home';
import RsvpEvent from './component/home/rsvpEvent';
import UnSub from './component/home/unsub';
import EventQrCode from './component/home/eventqrcode';
import ForgotPass from './component/home/forgotPass';
import NewPasswordCreate from './component/home/newPasswordCreate';
import Contact from './component/Misc/contact';
import ContactLoggedIn from './component/Misc/contactLoggedIn';
import Nav from './component/Misc/Nav';
import NavLoggedIn from './component/Misc/NavLoggedIn';
import About from './component/about/about.jsx';
import EventId from './component/home/eventid';
import NavBarEvent from './component/Misc/NavBarEvent';


axios.defaults.withCredentials = true;

function App () {

    return (
        
        <BrowserRouter>
            <Switch>
                <Route exact path="/login">
                    <Nav />
                    <Login />
                </Route>
                <Route exact path="/home">
                    <NavLoggedIn />
                    <Home />
                </Route>
                <Route exact path="/signup">
                    <Nav />
                    <Signup />
                </Route>
                <Route exact path="/rsvpEvent/:id/:cid/:spots">
                    <RsvpEvent />
                </Route>
                <Route exact path="/unSubscribe/:id">
                    <UnSub />
                </Route>
                <Route exact path="/eventqrcode/:title/:time/:date/:location/:id">
                    <EventQrCode />
                </Route>
                <Route exact path="/passwordreset">
                    <Nav />
                    <ForgotPass />
                </Route>
                <Route exact path="/newpasswordcreate/:user">
                    <NewPasswordCreate />
                </Route>
                <Route exact path="/contact">
                    <Nav />
                    <Contact />
                </Route>
                <Route exact path="/contactloggedin">
                    <NavLoggedIn />
                    <ContactLoggedIn />
                </Route>
                <Route exact path="/">
                    <Nav />
                    <About />
                </Route>
                <Route exact path="/eventid/:eventid">
                    <NavBarEvent />
                    <EventId />
                </Route>
            </Switch>
        </BrowserRouter>
        
    );
}

export default App;

